BatchGeoStore.addReducer(
  "BatchGeoContextMenu",
  { triggeringRow: null },
  {
    //We use CONTEXT_MENU_OPEN when the context menu is opened. It is used to track which row on the table was clicked to
    //open the context menu in order to perform actions to a row without the row needing to be previously selected.
    //For example, if a user were to right click on the batchgeo table with no rows selected,
    //and clicked "zoom to marker", we can now grab which row opened the context menu with `triggeringRow`,
    //and "select" the appropriate marker based on the row's id.
    CONTEXT_MENU_OPEN: function (state, action) {
      return Object.assign({}, state, {
        triggeringRow: action.clickedRow,
      });
    },
  },
);
